import React from 'react'
import { Link } from 'react-router-dom'

// styles & images
import './Navbar.css'
import Temple from '../../assets/temple.svg'

// hooks
import { useAuthLogout } from '../../Hooks/useAuthLogout'
import { useAuthContext } from '../../Hooks/useAuthContext'


export default function Navbar() {
  const { logout, isPending } = useAuthLogout();
  const { user } = useAuthContext()

  return (
    <div className='navbar'>
        <ul>
            <li className="logo" href="/">
                <img src={Temple} alt="dojo logo" />
                <span>The DoJo</span>
            </li>
            {!user && <><li><Link to="/login">Login</Link></li>
            <li><Link to="/signup">Signup</Link></li></>}
            {user && <><li>
              { !isPending && <button className="btn" onClick={logout}>Logout</button>}
              { isPending && <button disabled className="btn" >Logging out...</button>}
            </li></>}
        </ul>
    </div>
  )
}
